import PropTypes from "prop-types";

// material-ui
import { Avatar, Badge } from "@mui/material";

// project imports
import AvatarStatus from "./AvatarStatus";

// assets
const avatarImage = require.context("assets/images/users", true);

// ==============================|| CHAT USER AVATAR WITH STATUS ICON ||============================== //
const getInitial = (name) => {
  return name?.charAt(0)?.toUpperCase() || "?";
};
const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str?.length; i++) {
    hash = str?.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = hash % 360;
  return `hsl(${h}, 70%, 80%)`;
}
const UserAvatar = ({ user }) => (
  <Badge
    overlap="circular"
    badgeContent={<AvatarStatus status={user.online_status} />}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
  >
    {/* <Avatar alt={user.name} src={user.avatar && avatarImage(`./${user.avatar}`)} /> */}
    <Avatar
      alt={` ${user?.connectionName}`}
      src={user?.image?.data ? `data:image/*;base64, ${user?.image?.data}` : undefined}
      sx={{
        width: 42,
        height: 42,
        bgcolor: stringToColor(user?.connectionName),
        border: user?.image?.data
          ? "none"
          : `2px solid hsl(${(() => {
            let hash = 0;
            const name = user?.connectionName || "";
            for (let i = 0; i < name.length; i++) {
              hash = name.charCodeAt(i) + ((hash << 5) - hash);
            }
            return hash % 360;
          })()}, 70%, 60%)`,
      }}
    >{getInitial(user?.name)}</Avatar>
  </Badge>
);

UserAvatar.propTypes = {
  user: PropTypes.object,
};

export default UserAvatar;
